class BESSAppDependencyEvent extends BESSAppEvent {

    constructor(name, value, changing) {
        super(name);
        this.value = value;
        this.changing = changing;
    }

    getValue() {
        return this.value;
    }
}